export interface ReleaseUserFelicaIdRequest {
  id: string
}

export function ReleaseUserFelicaIdRequestToJSON(
  value: ReleaseUserFelicaIdRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
